export default __webpack_public_path__ + "static/media/4.a4177aa8.jpg";